(ns frontend.view.components.attachments
  (:require-macros [frontend.macros :refer [without-default-action-and-propagation]])
  (:require
   [common.dates :as d :include-macros true]
   [common.localization :as loc]
   [frontend.actions.attachment :as attachment-actions]
   [frontend.actions.common :as common-actions]
   [frontend.bootstrap.components :as rbs]
   [frontend.logging :as logging]
   [frontend.utils :as utils]
   [frontend.utils :as fu]
   [frontend.view.modals.delete-confirmation.view :as delete-confirmation-modal]
   [frontend.view.modals.events :as modals]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.card.view :as card]))

(defn upload-attachment!
  [filename description file target]
  (let [attachment {:filename    filename
                    :description description
                    :file        file
                    :target      target}
        on-success! (fn [token]
                      (attachment-actions/*=>add-attachment
                       {:multipart-params (assoc attachment :token token)
                        :progress         (fn [prog])}
                       (fn [resp])
                       (partial logging/error "Error in uploading attachment")))]
    (common-actions/*<-create-op-token nil
                                       on-success!
                                       (partial logging/error "resp token="))))

(defn remove-attachment!
  [target-id attachment]
  (attachment-actions/*<-remove-attachment
   {:target-id target-id :attachment-id (:db/id attachment)}
   (partial logging/unimplemented "remove-attachment! Success")
   (partial logging/error "remove-attachment! failed")))

(defn long->formatted-date
  [ms]
  (-> ms
      js/Date.
      (d/format {:pattern (loc/tr :attachment/date-format)})))

(defn uploader-text
  [account role]
  (let [name (if (#{:role/guest-sell-side} role)
               (str (:account/first-name account) " " (:account/last-name account))
               (:account/first-name account))
        role-text (case role
                    :role/guest-sell-side (str " (" (loc/tr :guest-sell-side) ")")
                    nil)]
    (str name role-text)))

(defn attachment-view
  [{:keys [attachment accounts target user-role]}]
  (let [{:keys [attachment/filename attachment/uploader attachment/created attachment/uploader-role]} attachment
        account (->> accounts
                     (filter (fn [account]
                               (= (:db/id account) uploader)))
                     first)
        uploader-text (uploader-text account uploader-role)]
    [rbs/ListGroupItem
     {:class "deal-attachments-list-attachment"}
     [:div.deal-attachments-list-attachment-right
      [:span
       [:span.deal-attachments-list-attachment__account
        uploader-text]
       (when-not (or (nil? created) (zero? created))
         [:span.deal-attachments-list-attachment__created
          (long->formatted-date created)])]
      (when-not (#{:role/guest-sell-side :role/guest-buy-side} user-role)
        [:div.inline-flex
         {:class-name "deal-attachments-list-attachment__buttons"}
         [button/square-secondary-hollow
          {:on-click (without-default-action-and-propagation
                      (modals/open-modal!
                       delete-confirmation-modal/modal-key
                       {:body       (loc/tr :attachment-delete)
                        :on-delete! #(remove-attachment! target attachment)}))}
          [:i.fal.fa-trash-alt]]
         #_[button/square-secondary-hollow                                                          ;; TODO these two buttons implemented later
            {:on-click (fn [e]
                         (.preventDefault e)
                         (.stopPropagation e))}
            [:i.fal.fa-thumb-tack]]
         #_[button/square-secondary-hollow
            [:i
             {:class-name (if true "fa fa-star-o" "fa fa-star")}]]])]
     [:div.deal-attachments-list-attachment-left
      {:on-click #(utils/open-attachment! (:db/id attachment))}
      [:i.fal.fa-paperclip.deal-attachments-list-attachment__icon]
      [:span.deal-attachments-list-attachment__filename filename]]]))

(defn attachment-upload-view
  [{:keys [target button-content button-class]
    :or   {button-class   ""
           button-content (loc/tr :add-document)}}]
  (let [state (r/atom nil)]
    (fn [{:keys [target]}]
      (let [{:keys [editor? file filename description]} @state]
        [:div.deal-attachments-upload
         [button/secondary-hollow                                                                   ;:button.deal-attachments-upload__add
          {:on-click #(swap! state assoc :editor? true)
           :class    button-class}
          button-content]
         [card/card
          {:class-name "deal-attachments-upload-editor-container"}
          [rbs/Collapse
           {:in (boolean editor?)}
           [:div.deal-attachments-upload-editor
            [:div.deal-attachments-upload-editor-field
             [:input
              {:class-name "deal-attachments-upload-editor__file"
               :on-change  (fn [e]
                             (let [file (aget (-> e
                                                  .-target
                                                  .-files)
                                              0)]
                               (swap! state
                                      assoc
                                      :file
                                      file
                                      :filename
                                      (.-name file))))
               :type       "file"}]]]
           #_[:div.deal-attachments-upload-editor-field
              [:label.deal-attachments-upload-editor__label
               (loc/tr :description)]
              [:input.deal-attachments-upload-editor__input
               {:type      "text"
                :value     description
                :on-change #(swap! state
                                   assoc
                                   :description
                                   (-> %
                                       .-target
                                       .-value))}]]
           [rbs/ButtonToolbar
            [button/danger-solid
             {:on-click #(reset! state nil)}
             (loc/tr :cancel)]
            [button/primary-solid
             {:disabled? (not file)
              :on-click  (fn [_]
                           (upload-attachment! filename description file target)
                           (reset! state nil))
              :class     (fu/cs "float-right" "" "deal-attachments-upload-editor__button")}
             (loc/tr :upload)]]]]]))))

(defn attachments-list
  [{:keys [target attachments accounts user-role]}]
  [rbs/ListGroup
   (doall (for [attachment attachments]
            ^{:key (str "attachment-view_" (:db/id attachment))}
            [attachment-view
             {:attachment attachment
              :target     target
              :accounts   accounts
              :user-role  user-role}]))])

(defn attachments-view
  [{:keys [target attachments accounts user-role] :as view-args}]
  [:div.deal-attachments
   [attachments-list view-args]
   [attachment-upload-view {:target target}]])
